import {
  Box,
  Flex,
  Heading,
  Text,
  VStack,
  Image,
  HStack,
  Icon,
  Container,
} from "@chakra-ui/react";
import { BrandButton } from "../../components/BrandButton/BrandButton";
import { FaArrowRightLong } from "react-icons/fa6";
import { GiCheckMark } from "react-icons/gi";
import { UserService } from "../../services/UserService";
import { useSelector } from "react-redux";
import { RootState } from "@/services/state/store";

export interface featureTabProb {
  index: number;
  image: string;
  title: string;
  description: string[];
}

export function FeatureTab({
  index,
  image,
  title,
  description,
}: featureTabProb) {
  return (
    <VStack backgroundColor="white">
      <style>
        {`
          @media (max-width: 1380px) {
            .responsive-images {
              width: 750px;
              height: 330px;
            }
          }
        `}
      </style>
      <Flex
        direction="row"
        width="70%"
        alignItems="center"
        paddingY="56px"
        gap="16px"
        borderRadius="md"
        justifyContent="space-between"
      >
        {index % 2 === 0 ? (
          <>
            <Flex direction="column" width="50%">
              <Box>
                <Image
                  src={image}
                  alt={image}
                  className="responsive-images"
                  width="636px"
                  height="350px"
                />
              </Box>
            </Flex>
            <Flex direction="column" mx={12} gap={4} width="50%">
              <Heading>{title}</Heading>
              {description.map((feature, i) => (
                <Text key={i} color="gray.500">
                  {feature}
                </Text>
              ))}
            </Flex>
          </>
        ) : (
          <>
            <Flex direction="column" mx={12} gap={4} width="50%">
              <Heading>{title}</Heading>
              {description.map((feature, i) => (
                <Text key={i} color="gray.500">
                  {feature}
                </Text>
              ))}
            </Flex>
            <Flex direction="column" width="50%">
              <Box>
                <Image
                  src={image}
                  alt={image}
                  className="responsive-images"
                  width="636px"
                  height="350px"
                />
              </Box>
            </Flex>
          </>
        )}
      </Flex>
    </VStack>
  );
}

export const LandingPage = () => {
  const platformFeatures = {
    image: "all2.png",
    title: "Platform Features",
    description: [
      " Connect to your live cameras or upload your videos",
      " Get Analytics in Real-time",
      " A library of short videos from Cameras/ Videos",
      " Alerts to email and their history",
      " Download and Share Analytics Reports",
      " Overall Analytics Summary and Reasoning",
    ],
  };

  const explainTabs = [
    {
      image: "vanalytics.png",
      title: "Gain in-depth insights from your videos",
      description: [
        "Our AI algorithms dissect videos to uncover insights, trends, and patterns thatwere once hidden.",
        "From optimizing marketing strategies to enhancing security measures, Eizen's video analytics pave the way to smarter decisions.",
      ],
    },
    {
      image: "summary.png",
      title: "Get the big picture with video summaries",
      description: [
        "Our AI Interactive Agents watch, summarize, and extract the essence of lengthy videos, condensing hours into minutes.",
        "Perfect for busy professionals, educators, and anyone who values their time.",
      ],
    },
    {
      image: "reasoning.png",
      title: 'Understand the "why" behind every frame',
      description: [
        "It's not just about seeing; it's about understanding. Eizen's video reasoning capabilities go beyond visual recognition.",
        "Our AI deciphers the 'why' behind the 'what' in videos, offering context and actionable insights.",
      ],
    },
  ];

  const onBookingDemo = () => {
    window.location.href = "https://eizen.ai/demo.html";
  };

  const isLogoEnaable = useSelector(
    (state: RootState) => state.administration.isLogoEnabled
  );
  return (
    <>
      <Box
        as="header"
        w="full"
        bgColor="white"
        boxShadow="0px 1px 2px 0px #0000000D"
        p={"16px"}
      >
        {/* <Container> */}
        {isLogoEnaable ? (
          <Flex
            width="100%"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            px={48}
          >
            <Image src="Logo-Full.png" alt="Logo" w="145px" h="45px" />

            <BrandButton size="md" onClick={() => UserService.doLogin()}>
              Log in
            </BrandButton>
          </Flex>
        ) : (
          <Flex
            width="100%"
            flexDirection="row"
            justifyContent="end"
            alignItems="center"
            px={48}
          >
            <BrandButton size="md" onClick={() => UserService.doLogin()}>
              Log in
            </BrandButton>
          </Flex>
        )}
        {/* </Container> */}
      </Box>

      <Box
        backgroundImage='url("Section.png")'
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
      >
        <HStack justifyContent="center">
          <Flex
            direction="row"
            alignItems="center"
            width="80%"
            paddingY="96px"
            style={{ overflow: "hidden" }}
          >
            <Flex direction="column" width="50%" m={8}>
              <HStack justifyContent="center">
                <VStack alignItems="flex-start" gap="24px" width="80%">
                  <Heading fontSize="36px" fontWeight="700" textColor="#2D1D61">
                    Transforming Videos into Actionable Intelligence
                  </Heading>
                  <Text textColor="gray.500">
                    Harness the full potential of videos, turning them into
                    invaluable assets for your business with Generative AI.
                  </Text>
                  <BrandButton size="md" onClick={() => UserService.doLogin()}>
                    <HStack>
                      <Text>Login</Text>
                      <Icon as={FaArrowRightLong as React.ElementType} />
                    </HStack>
                  </BrandButton>
                </VStack>
              </HStack>
            </Flex>
            <Flex direction="column" width="50%">
              <HStack justifyContent="center">
                <Image src="all2.png" alt="Hero" height="520px" width="640px" />
              </HStack>
            </Flex>
          </Flex>
        </HStack>
      </Box>

      <Box>
        <Flex
          direction="column"
          alignItems="center"
          paddingY={"56px"}
          gap="16px"
          backgroundColor="white"
        >
          <Heading as="h2" fontSize="36px" fontWeight="600">
            {isLogoEnaable && (
              <Box as="span" textColor="brand.700">
                Eizen:
              </Box>
            )}
            <Box as="span" textColor="black">
              Where Every Frame Tells a Story, and{" "}
            </Box>
            <Box as="span" textColor="brand.700">
              AI{" "}
            </Box>
            <Box as="span" textColor="black">
              Translates It.
            </Box>
          </Heading>
          <video
            width="998"
            height="560"
            controls
            style={{
              borderWidth: "2px",
              borderColor: "gray.300",
              borderRadius: "6px",
            }}
            controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
            disablePictureInPicture
            disableRemotePlayback
          >
            <source src="VI.mp4" type="video/mp4" />
          </video>
        </Flex>

        <VStack backgroundColor="white">
          <Flex
            direction="row"
            width="70%"
            alignItems="center"
            paddingY="56px"
            gap="16px"
            backgroundColor="brand.200"
            borderRadius="25px"
            justifyContent="space-between"
          >
            <Flex direction="column" mx={12} gap={4}>
              <Heading>{platformFeatures.title}</Heading>
              {platformFeatures.description.map((feature, i) => (
                <HStack key={i}>
                  <Icon
                    as={GiCheckMark as React.ElementType}
                    color="gray.500"
                  />
                  <Text color="gray.500">{feature}</Text>
                </HStack>
              ))}
              <BrandButton size="md" width="60%" onClick={onBookingDemo}>
                <HStack>
                  <Text>Book a demo</Text>
                  <Icon as={FaArrowRightLong as React.ElementType} />
                </HStack>
              </BrandButton>
            </Flex>
            <Flex direction="column" mr={8}>
              <style>
                {`
                  @media (max-width: 1380px) {
                    .responsive-image {
                      width: 570px;
                      height: 380px;
                    }
                  }
                `}
              </style>
              <Image
                src={platformFeatures.image}
                alt="all"
                className="responsive-image"
                height="450px"
                width="550px"
                pr={4}
              />
            </Flex>
          </Flex>
        </VStack>

        {explainTabs.map((tab, index) => (
          <FeatureTab
            key={index}
            index={index}
            image={tab.image}
            title={tab.title}
            description={tab.description}
          />
        ))}
      </Box>

      <Box
        p="24px"
        boxShadow="0px 10px 10px -5px #0000000A, 0px 20px 25px -5px #0000001A"
        bgColor="#121212"
      >
        <Container>
          <Flex direction="column" gap={2}>
            {isLogoEnaable && (
              <Flex direction="row" justifyContent="center">
                <Image src="logo_eizen.png" alt="Logo" />
              </Flex>
            )}
            <Flex direction="row" justifyContent="center">
              <Text fontSize="12px" fontWeight="500" color="#D9D9D9">
                {isLogoEnaable
                  ? "Copyright © 2024 eizen V2.0 - All Rights Reserved."
                  : "Copyright © 2024 V2.0 - All Rights Reserved."}
              </Text>
            </Flex>
          </Flex>
        </Container>
      </Box>
    </>
  );
};
